module.exports = __webpack_public_path__ + "img/sld_mfm_lt_panel_t1_b1 1.ae6cfc4c.svg";